<motn-drawer-height-from-bottom
  [addToBottomHeight]="100"
  (clickedOutside$)="clickedOutside$.emit()"
>
  <h3>
    Configure Point
    <motn-pill color="indigo">LoRaWAN</motn-pill>
  </h3>

  <div class="editor">
    <div class="group">
      <div>
        <input [(ngModel)]="name" placeholder="e.g. temperature">
        <div class="label">Point Name</div>
      </div>

      <div>
        <select [(ngModel)]="type">
          <option [value]="LoRaWANPointType.UplinkPayload">UP</option>
          <option [value]="LoRaWANPointType.UplinkMetadata">UM</option>
        </select>
        <div class="label">Data Source</div>
      </div>

      <div>
        <select [(ngModel)]="format">
          <option [value]="LoRaWANPointFormat.Numeric">num</option>
          <option [value]="LoRaWANPointFormat.Boolean">bool</option>
        </select>
        <div class="label">Data Type</div>
      </div>
    </div>

    <div class="button-group">
      <button
        [ngClass]="{'small': true, 'loading': saving}"
        [disabled]="!name.trim() || saving"
        (click)="save()"
      >
        <span>Save</span>
        <motn-spinner></motn-spinner>
      </button>
    </div>
  </div>
</motn-drawer-height-from-bottom>
